import { loader } from 'graphql.macro'

export default function reportsTicketOverviewQuery ({ dataLoaders, queryKey }) {
  const [,
    years,
    resourceTypes,
    ticketTypes,
    status,
    drivers,
    yearToDate
  ] = queryKey

  const reportsTicketOverviewSchema = loader('./reportsTicketOverview.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(reportsTicketOverviewSchema, { years, resourceTypes, ticketTypes, status, drivers, yearToDate })
}
